import React from 'react';
import { Typography, Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { CountryCode, StreetAddress } from 'API';
import { resolvers } from 'shared/enums';
import { countryCodeResolver } from 'shared/geoResolvers';

interface Props {
  address?: StreetAddress;
  hideCountry?: boolean;
  variant?: 'body1' | 'body2';
  sx?: SxProps<Theme>;
}

const StreetAddressDisplay: React.FC<Props> = ({
  address, hideCountry, variant, sx,
}: Props) => {
  const stateProvince = address?.city
    ? address.state || address.adminArea // If city and state, abbreviate
    : address?.adminArea;

  if (!address) {
    return null;
  }

  return (
    <Box sx={sx}>
      {address.address && (
        <Typography
          sx={{ whiteSpace: 'pre-wrap' }}
          variant={variant || 'body1'}
        >
          {address.address}
        </Typography>
      )}
      {address.careOf && (
        <Typography
          variant={variant || 'body1'}
        >
          {address.careOf}
        </Typography>
      )}
      {(address.unitType || address.unitNumber) && (
        <Typography variant={variant || 'body1'}>
          {address.unitType && resolvers.UnitType(address.unitType)}
          {' '}
          {address.unitNumber}
        </Typography>
      )}
      {(address.city || stateProvince) && (
        <Typography variant={variant || 'body1'}>
          {address.city && address.city}
          {address.city && stateProvince && ', '}
          {stateProvince && stateProvince}
        </Typography>
      )}
      {address.postalCode && (
        <Typography variant={variant || 'body1'}>
          {address.postalCode}
        </Typography>
      )}
      {!hideCountry && address.country && (
        <Typography variant={variant || 'body1'}>
          {countryCodeResolver(address.country as CountryCode)}
        </Typography>
      )}
    </Box>
  );
};

export default StreetAddressDisplay;
